import { CategoryData } from 'types/CategoryData';
import { ProductData } from 'types/ProductData';
import PublicRoute from 'enums/publicRoutes';

export interface ProductBreadcrumb {
  id: number;
  name: string;
  path: string;
}

const LEVELS = [
  { idOf: (p: ProductData) => p.group_id, param: 'main-category' },
  { idOf: (p: ProductData) => p.category_id, param: 'sub-category' },
  { idOf: (p: ProductData) => p.product_id, param: 'sub-subcategory' },
];

const findById = (categories?: CategoryData[], id?: number | null) =>
  id ? categories?.find((category) => category.id === id) : undefined;

export const buildProductBreadcrumbs = (
  product?: ProductData,
  categoryTree?: CategoryData[],
  isEmarket = true
): ProductBreadcrumb[] => {
  if (!product) return [];

  const basePath = isEmarket
    ? PublicRoute.PRODUCTS_ALL
    : PublicRoute.WHOLESALE_PRODUCTS_ALL;

  const params = new URLSearchParams();
  const crumbs: ProductBreadcrumb[] = [];

  let siblings = categoryTree ? Object.values(categoryTree) : [];

  for (const level of LEVELS) {
    const category = findById(siblings, level.idOf(product));
    if (!category?.id || !category.name) break;

    params.set(level.param, String(category.id));
    crumbs.push({
      id: category.id,
      name: category.name,
      path: `${basePath}?${params.toString()}`,
    });

    siblings = category.subcategories ?? [];
  }

  return crumbs;
};
